// Steps
import { Step10Workflow } from '../components/spaces/wizard/steps/Step10Workflow';
import { Step11Marketing } from '../components/spaces/wizard/steps/Step11Marketing';
import { Step1BasicInfo } from '../components/spaces/wizard/steps/Step1BasicInfo';
import { Step2RequesterConfig } from '../components/spaces/wizard/steps/Step2RequesterConfig';
import { Step3EventTypes } from '../components/spaces/wizard/steps/Step3EventTypes';
import { Step4DateManagement } from '../components/spaces/wizard/steps/Step4DateManagement';
import { Step5RequiredDocs } from '../components/spaces/wizard/steps/Step5RequiredDocs';
import { Step6CapacityBrackets } from '../components/spaces/wizard/steps/Step6CapacityBrackets';
import { Step7RoomLayouts } from '../components/spaces/wizard/steps/Step7RoomLayouts';
import { Step8Equipment } from '../components/spaces/wizard/steps/Step8Equipment';
import { Step9Catering } from '../components/spaces/wizard/steps/Step9Catering';

export interface StepConfig {
  id: string;
  label: string;
  description: string;
  component: any;
  isOptional?: boolean;
}

export const WORKFLOWS = [
  {
    value: 'IMMEDIATE',
    label: 'Réservation immédiate',
    description: 'Le client réserve et paie directement en ligne',
    color: '#00758d',
  },
  {
    value: 'QUOTE_REQUIRED',
    label: 'Sur devis',
    description: 'Le client demande un devis, vous répondez sous 48h',
    color: '#8E0B56',
  },
  {
    value: 'APPLICATION_REQUIRED',
    label: 'Sur dossier',
    description: 'Le client soumet un dossier, vous validez la demande',
    color: '#00303c',
  },
];

export const STEPS: StepConfig[] = [
  {
    id: 'basic',
    label: 'Informations de base',
    description: 'Nom, description et type de réservation',
    component: Step1BasicInfo,
  },
  {
    id: 'requester',
    label: 'Configuration demandeur',
    description: 'Champs du formulaire demandeur',
    component: Step2RequesterConfig,
    isOptional: true,
  },
  {
    id: 'events',
    label: "Types d'événements",
    description: "Définir les types d'événements",
    component: Step3EventTypes,
  },
  {
    id: 'dates',
    label: 'Gestion des dates',
    description: 'Mono/multi-dates et durées',
    component: Step4DateManagement,
  },
  {
    id: 'documents',
    label: 'Documents obligatoires',
    description: 'Documents requis pour réserver',
    component: Step5RequiredDocs,
  },
  {
    id: 'capacity',
    label: 'Tranches de capacité',
    description: 'Capacités et tarifs',
    component: Step6CapacityBrackets,
  },
  {
    id: 'layouts',
    label: 'Mises en place',
    description: 'Configurations de salle',
    component: Step7RoomLayouts,
    isOptional: true,
  },
  {
    id: 'equipment',
    label: 'Équipements & Options',
    description: 'Options payantes et incluses',
    component: Step8Equipment,
    isOptional: true,
  },
  {
    id: 'catering',
    label: 'Restauration',
    description: 'Pause café et repas',
    component: Step9Catering,
    isOptional: true,
  },
  {
    id: 'workflow',
    label: 'Workflow & Devis',
    description: 'Configuration des devis',
    component: Step10Workflow,
    isOptional: true,
  },
  {
    id: 'summary',
    label: 'Récapitulatif & Affichage',
    description: 'Vérifier et publier',
    component: Step11Marketing,
  },
];
